module.exports = __webpack_public_path__ + "img/tippertruck.4e80832d.svg";